import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import {
  Avatar,
  Box,
  Button,
  Flex,
  Grid,
  Link,
  Text,
  Tooltip,
  useToast,
} from "@chakra-ui/react";
import "./form.css";

const Form = () => {
  const form = useRef();
  const toast = useToast();
  const [loading, setLoading] = useState(false);
  const sendEmail = (e) => {
    e.preventDefault();
    setLoading(true);
    emailjs
      .sendForm(
        "service_exkrohr",
        "template_2cbo6ap",
        form.current,
        "4REn_0gMxxox-iEzd"
      )
      .then(
        (result) => {
          toast({
            title: "Message Sent.",
            description: result.text,
            status: "success",
            duration: 3000,
            isClosable: true,
          });
          setLoading(false);
          form.current.reset();
        },
        (error) => {
          toast({
            title: "An error occurred.",
            description: error.text,
            status: "error",
            duration: 9000,
            isClosable: true,
          });
          setLoading(false);
        }
      );
  };

  return (
    <Flex flexDirection={{ lg: "row", md: "column", sm: "column" }}>
      <Box
        // border="1px"
        // borderColor="red"
        w={{ lg: "45%", md: "100%", sm: "100%" }}
      >
        <Box
          w={{ lg: "80%", md: "60%", sm: "94%" }}
          //   border="1px"
          //   borderColor="black"
          className="outerbox"
          margin={{ lg: "0px", md: "auto", sm: "auto" }}
          marginLeft="100px"
        >
          <Box className="form">
            <form ref={form} onSubmit={sendEmail}>
              <input
                className="form-input"
                type="text"
                placeholder="Full Name"
                name="from_name"
                required
              />
              <input
                className="form-input"
                type="email"
                name="user_email"
                placeholder="Email"
                required
              />

              <textarea
                placeholder="Message"
                className="form-input"
                rows="10"
                cols="25"
                name="message"
                id="message-input"
              ></textarea>
              <Button
                isLoading={loading}
                mt="20px"
                w="100%"
                loadingText="Submitting"
                colorScheme="teal"
                variant="outline"
                fontWeight="bold"
                color="rgb(66, 184, 184)"
              >
                <input
                  type="submit"
                  style={{ width: "100%", background: "transparent" }}
                  value="Send"
                ></input>
              </Button>
            </form>
          </Box>
        </Box>
      </Box>
      <Box m="auto">
        {" "}
        <Box>
          <Grid
            py={{ lg: "30px", md: "15px", sm: "10px" }}
            templateColumns={{
              lg: "repeat(2, 1fr)",
              md: "repeat(2, 1fr)",
              sm: "repeat(2, 1fr)",
            }}
            gap={{ lg: "100px", md: "70px", sm: "10px" }}
          >
            {CONTACTS.map((el) => (
              <Flex key={el.id} align="center">
                <Link href={el.link} target="_blank">
                  <Tooltip placement="top" hasArrow label={el.label}>
                    <Avatar
                      size={{ lg: "md", md: "md", sm: "xs" }}
                      name={el.name}
                      src={el.image}
                    />
                  </Tooltip>
                </Link>
                <Text
                  fontSize={["9px", "12px", "14px"]}
                  ml={{ lg: "6px", md: "6px", sm: "6px" }}
                >
                  {el.label}
                </Text>
              </Flex>
            ))}
          </Grid>
        </Box>
      </Box>
    </Flex>
  );
};

const CONTACTS = [
  {
    id: 1,
    link: "tel:8840904668",
    label: "8840904668",
    name: "Faizal Siddiqui",
    image: "./whats-app.png",
  },
  {
    id: 2,
    link: "mailto:faizalsidp@gmail.com",
    label: "faizalsidp@gmail.com",
    name: "faizalsidp@gmail.com",
    image: "./gmail.png",
  },
  {
    id: 3,
    link: "https://www.linkedin.com/in/faizal-siddiqui/",
    label: "faizal-siddiqui",
    name: "faizal-siddiqui",
    image: "./linkedin.png",
  },
  {
    id: 4,
    link: "https://github.com/faizal-siddiqui",
    label: "faizal-siddiqui",
    name: "faizal-siddiqui",
    image: "./github.png",
  },
];

export default Form;
